export enum UploadOption {
  selectFiles = 'SelectFiles',
  selectFolder = 'SelectFolder',
  selectZipFiles = 'SelectZipFiles'
}